import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=c56287e2&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=c56287e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56287e2",
  null
  
)

export default component.exports